interface ContainerFluidProps {
  className?: string
  children: React.ReactNode
}

const ContainerFluid = ({ className, children }: ContainerFluidProps) => {
  return (
    <div className={`container-fluid p-5 vh-200 ${className}`}>{children}</div>
  )
}

export default ContainerFluid
